// Shows a "games closed / take a break" banner when a gated game is outside its
// IST play window or on a non-active day. Renders nothing when the game is accessible.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Clock } from "lucide-react";

export default function GameWindowBanner({ game }) {
  const [w, setW] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get(`/game-window?game=${game}`).then((r) => { if (alive) setW(r.data); }).catch(() => {});
    return () => { alive = false; };
  }, [game]);

  if (!w || w.accessible) return null;

  let nextLabel = "";
  try { nextLabel = new Date(w.next_open_ist).toLocaleString(); } catch { nextLabel = ""; }

  return (
    <div
      data-testid="game-window-banner"
      className="border-2 themed-border p-4 text-center brutal-shadow-sm"
      style={{ background: "var(--bq-accent2)" }}
    >
      <div className="flex items-center justify-center gap-2 uppercase font-black text-lg">
        <Clock size={18} /> {w.is_active_day ? "Games are closed right now" : "Take a break!"}
      </div>
      <p className="text-sm mt-1 font-bold">{w.message}</p>
      {nextLabel && (
        <p className="text-xs mt-1 font-mono-bq" style={{ color: "var(--bq-muted)" }}>
          Active days: {(w.active_day_names || []).join(", ")} · Next window: {nextLabel}
        </p>
      )}
    </div>
  );
}
